document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("table").forEach(table => {
        const cells = table.querySelectorAll("td");
        
        cells.forEach(cell => {
        cell.addEventListener("mouseenter", () => {
            const colIndex = cell.cellIndex;
            table.querySelectorAll("tr").forEach(row => {
            if (row.cells[colIndex]) {
                row.cells[colIndex].classList.add("highlight-col");
            }
            });
        });
        cell.addEventListener("mouseleave", () => {
            const colIndex = cell.cellIndex;
            table.querySelectorAll("tr").forEach(row => {
            if (row.cells[colIndex]) {
                row.cells[colIndex].classList.remove("highlight-col");
            }
            });
        });
        });
    });
});
